import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const Lab = () => {
  return (
    <section id="lab-management" className="landing lab-landing">
      <Helmet>
        <title>Lab Management Software India — Mediway Nextgen</title>
        <meta name="description" content="Lab Management Software (LIS) for hospitals and diagnostic centres in India — test order management, result entry, auto-reporting, barcode printing and integration with EMR by Mediway Nextgen." />
        <link rel="canonical" href="https://mediwaynextgen.wayug.com/services/lab-management-software" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Product',
            'name': 'Lab Management Software',
            'description': 'Laboratory Information System (LIS) for hospitals and diagnostic centres in India — test management, barcode printing, auto-reporting and EMR integration.',
            'brand': 'Mediway Nextgen',
            'url': 'https://mediwaynextgen.wayug.com/services/lab-management-software'
          })}
        </script>
      </Helmet>

      <div className="container">
        <header className="section-header">
          <h2 className="section-title">Lab Management Software — Complete Laboratory Information System</h2>
          <p className="section-subtitle">End-to-end lab test lifecycle management for hospitals and diagnostic centres in India — from order entry and sample collection to result reporting and billing.</p>
        </header>

        <div className="service-content">
          <div className="service-header">
            <div className="service-icon">🧪</div>
            <div className="service-info">
              <h3 className="service-title">Intelligent Laboratory Workflows</h3>
              <p className="service-description">Streamline your lab operations with automated test ordering, barcode-based sample tracking, instrument integration, and instant result delivery to clinicians — reducing turnaround time and manual errors.</p>
            </div>
          </div>

          <div className="service-body">
            <div className="service-features">
              <h4>Key Features</h4>
              <ul className="features-list">
                <li className="feature-item"><span className="feature-check">✓</span><span>Test order management &amp; sample tracking</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Barcode &amp; QR code label printing</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Auto-result entry &amp; normal range validation</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Lab instrument integration (HL7/ASTM)</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Branded PDF report generation &amp; delivery</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>NABL &amp; NABH compliance-ready workflows</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Integrated billing &amp; insurance claim support</span></li>
              </ul>
            </div>

            <div className="service-benefits">
              <h4>Benefits</h4>
              <div className="benefits-grid">
                <div className="benefit-card"><div className="benefit-icon">⚡</div><span>Faster turnaround time</span></div>
                <div className="benefit-card"><div className="benefit-icon">🎯</div><span>Reduce transcription errors</span></div>
                <div className="benefit-card"><div className="benefit-icon">📊</div><span>Real-time workload visibility</span></div>
                <div className="benefit-card"><div className="benefit-icon">🔗</div><span>Seamless EMR integration</span></div>
              </div>
            </div>
          </div>

          <div className="service-actions">
            <Link to="/contact" className="btn btn-primary">Request Lab Demo</Link>
            <Link to="/services" className="btn btn-secondary">All Services</Link>
          </div>
        </div>
      </div>

      <div className="services-background">
        <div className="background-pattern"></div>
      </div>
    </section>
  );
};

export default Lab;
